import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type UserService from 'walden-fast/services/user';

type Resolved<P> = P extends Promise<infer T> ? T : P;
export type AppManageSubscriptionsServicesModel = Resolved<
  ReturnType<AppManageSubscriptionsServicesRoute['model']>
>;

export default class AppManageSubscriptionsServicesRoute extends Route {
  @service('user') declare userService: UserService;

  model() {
    return {
      services: this.userService.user?.availableServices,
    };
  }
}
